import { ListUser } from 'domain/usecases/user/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from 'domain/errors';
import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import 'infra/global/variables';

export class RemoteListUser implements ListUser {
  private readonly url: string;

  private readonly httpClient: HttpClient<ListUser.Model>;

  constructor(url: string, httClient: HttpClient<ListUser.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  list = async (params: ListUser.Params): Promise<ListUser.Model> => {
    let query = '?';

    if (params.body?.filter) {
      Object.entries(params.body?.filter).forEach(([key, value]) => {
        if (value) query += `${key}=${value}&`;
      });
    }

    const httpResponse = await this.httpClient.request({
      url: `${this.url}${query}${
        params.body?.limit ? `limit=${params.body.limit}` : ''
      }`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
      case HttpStatusCode.notModified:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
